import Tibbit40_1Node from '@appblocks/codegeneration/Nodes/Tibbit40_1Node';
import { Setting, SettingType } from '@appblocks/codegeneration/types';
import Tibbit40Node from '@appblocks/codegeneration/Nodes/Tibbit40Node';

export default class Tibbit40_2Node extends Tibbit40Node {
    constructor() {
        super();
        this.name = 'Tibbit 40_2';
        this.id = 'node_tibbit_40_2';
        this.linkedFeature = 'tibbit_40_2';
        this.description = 'Digital potentiometer, 5KOhm';
        this.range = 10000;

        const settings: Setting[] = [
            {
                id: 'TIBBIT',
                name: 'Tibbit',
                settingType: SettingType.OPTION,
                required: true,
                refId: 'tibbit_40_2',
                default: '',
            },
        ];

        this.settings = this.settings.concat(settings);
    }
}
